/* Riora "Top 5" listicle: reading progress bar, [1]-style citation links, offer countdown. */
(function () {
  if (window.__rioraT5) return;
  window.__rioraT5 = true;

  /* Reading progress (top bar in the masthead section). */
  function progress() {
    var bar = document.querySelector('[data-t5-progress]');
    if (!bar || bar.dataset.t5Run) return;
    bar.dataset.t5Run = '1';
    var tick = false;
    function update() {
      tick = false;
      var doc = document.documentElement;
      var max = doc.scrollHeight - window.innerHeight;
      bar.style.width = (max > 0 ? Math.min(100, Math.max(0, (window.scrollY / max) * 100)) : 0) + '%';
    }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* Footnotes: editors type [1] or [1][2] in any text; it becomes a superscript link to the Citations section. */
  function cites(scope) {
    var target = document.getElementById('citations') ? '#citations' : null;
    var re = /((?:\[\d{1,2}\])+)/;
    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!re.test(n.nodeValue)) return NodeFilter.FILTER_REJECT;
        var p = n.parentNode;
        while (p && p !== scope) {
          if (p.nodeName === 'A' || p.nodeName === 'SCRIPT' || p.nodeName === 'STYLE' || p.nodeName === 'SUP' || (p.hasAttribute && p.hasAttribute('data-t5-nocite'))) return NodeFilter.FILTER_REJECT;
          p = p.parentNode;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (n) {
      var parts = n.nodeValue.split(re);
      var frag = document.createDocumentFragment();
      parts.forEach(function (part, i) {
        if (!part) return;
        if (i % 2 === 1) {
          var sup = document.createElement('sup');
          if (target) {
            var a = document.createElement('a');
            a.href = target;
            a.className = 't5-cite';
            a.textContent = part;
            sup.appendChild(a);
          } else {
            sup.textContent = part;
          }
          frag.appendChild(sup);
        } else {
          frag.appendChild(document.createTextNode(part));
        }
      });
      n.parentNode.replaceChild(frag, n);
    });
  }

  /* Countdown to the date set on the verdict section. Hides itself once the date has passed. */
  function clocks() {
    document.querySelectorAll('[data-t5-clock]').forEach(function (el) {
      if (el.dataset.t5Run) return;
      el.dataset.t5Run = '1';
      var end = Date.parse(el.getAttribute('data-t5-clock'));
      if (isNaN(end)) { el.hidden = true; return; }
      var d = el.querySelector('[data-d]'), h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function draw() {
        var left = Math.max(0, end - Date.now());
        if (!left) { el.hidden = true; clearInterval(t); return; }
        var sec = Math.floor(left / 1000);
        d.textContent = Math.floor(sec / 86400);
        h.textContent = pad(Math.floor((sec % 86400) / 3600));
        m.textContent = pad(Math.floor((sec % 3600) / 60));
        s.textContent = pad(sec % 60);
      }
      var t = setInterval(draw, 1000);
      draw();
    });
  }

  function boot() {
    progress();
    document.querySelectorAll('.t5').forEach(cites);
    clocks();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target;
    if (root && root.querySelector && root.querySelector('.t5')) { root.querySelectorAll('.t5').forEach(cites); clocks(); progress(); }
  });
})();
